"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Editor/Dialogs.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }/* The publish confirm (screen 14) and the delete confirm. */
var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);

var _rules = require('./rules');











 const PublishDialog = ({ isOpen, name, orgName, fields, isBusy, onPublish, onClose }) => (
  _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: `Publish "${name}"?`, size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}
    , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 21}}, "Once it's published, anyone in "
           ,  orgName || 'your org' , " can send it from any patient chat."
    )
    , _react2.default.createElement('table', { className: "forms-editor--publish-table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
      , _react2.default.createElement('tbody', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 25}}
        , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}, _react2.default.createElement('th', { scope: "row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}, "Families fill" ), _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 26}},  _rules.familiesFill.call(void 0, fields) ))
        , _react2.default.createElement('tr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, _react2.default.createElement('th', { scope: "row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}, "Staff fill before sending"   ), _react2.default.createElement('td', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 27}},  _rules.staffFill.call(void 0, fields) ))
      )
    )
    , _react2.default.createElement('p', { className: "forms-editor--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 30}}, "You can edit it later. Forms already sent keep the version they were sent with."              )
    , _react2.default.createElement(_Modal.ModalControls, {
      primaryBtnLabel: "Publish",
      isPrimaryLoading: isBusy,
      onPrimaryBtnClick: onPublish,
      secondaryBtnLabel: "Cancel",
      onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 31}}
    )
  )
); exports.PublishDialog = PublishDialog









 const DeleteDialog = ({ isOpen, name, isBusy, onDelete, onClose }) => (
  _react2.default.createElement(_Modal2.default, { isOpen: isOpen, onClose: onClose, title: `Delete "${name}"?`, size: "xs", __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}
    , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 51}}, "It leaves the Library. Forms already sent keep the version they were sent with."             )
    , _react2.default.createElement(_Modal.ModalControls, {
      primaryBtnTheme: "danger",
      primaryBtnLabel: "Delete",
      isPrimaryLoading: isBusy,
      onPrimaryBtnClick: onDelete,
      secondaryBtnLabel: "Cancel",
      onSecondaryBtnClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
    )
  )
); exports.DeleteDialog = DeleteDialog
